import { CartDiscountType } from '../../types/index.js';

const mapGraphCartDiscountToClientCartDiscount = (serverCartDiscounts)=>{
    return serverCartDiscounts.map(({ minimumQuantity , amount , type: type1  })=>{
        const mappedType = (type)=>{
            switch(type){
                case 'PERCENT':
                    return CartDiscountType.PERCENT;
                case 'AMOUNT':
                    return CartDiscountType.AMOUNT;
                default:
                    throw new Error(`Unknown cart discount type: ${type}`);
            }
        };
        return {
            minimumQuantity: minimumQuantity !== null && minimumQuantity !== void 0 ? minimumQuantity : 0,
            amount: amount !== null && amount !== void 0 ? amount : 0,
            type: mappedType(type1)
        };
    });
};

export { mapGraphCartDiscountToClientCartDiscount };
//# sourceMappingURL=map-to-client-cart-discount.js.map
